import { useKlineStore } from '../stores/use-kline'
import type { ResolutionString } from '../../../charting-library/charting_library'
import { useDoubleContractKlineStore } from '../stores/use-double-contract-kline'

export const useChangeResolution = (fn: (currentResolution: ResolutionString, oldResolution: ResolutionString) => void) => {
  const klineStore = useKlineStore()

  watch(
    () => klineStore.currentResolution,
    (currentResolution, oldResolution) => {
      if (currentResolution && oldResolution && currentResolution !== oldResolution) {
        fn(currentResolution, oldResolution)
      }
    },
  )
}

export const useContractChangeResolution = (fn: (currentResolution: ResolutionString, oldResolution: ResolutionString) => void) => {
  const doubleContractKlineStore = useDoubleContractKlineStore()

  watch(
    () => doubleContractKlineStore.currentResolution,
    (currentResolution, oldResolution) => {
      if (currentResolution && oldResolution && currentResolution !== oldResolution) {
        fn(currentResolution, oldResolution)
      }
    },
  )
}
